import { debounceTime, filter, map, take, withLatestFrom } from 'rxjs/operators';
import { OnFieldChanged } from '../../../../../../shared/modules/configurable-form/models/on-field-changed';
import { Store } from '@ngrx/store';
import { IShipmentLocation } from '@cemex-core/cmx-api/models/shipment-location/shipment-location';
import { Injectable } from '@angular/core';
import { getJobsiteSelected, getPointOfDeliveryState, OrderBuilderState } from '../../../../../reducers';
import { PointOfDeliverySetAction } from '../../../actions/point-of-delivery-actions/point-of-delivery.actions';

@Injectable()
export class PointOfDeliverySetCommand implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(value: number): void {
    this.store
      .select(getPointOfDeliveryState)
      .pipe(
        debounceTime(500),
        take(1),
        withLatestFrom(this.store.select(getJobsiteSelected)),
        map(([state, jobsite]) => {
          if (jobsite && value === jobsite.shipmentLocationId) {
            return jobsite;
          }
          return state.pointOfDeliveries.find((pod: IShipmentLocation) => {
            return pod.shipmentLocationId === value;
          });
        }),
        filter(Boolean),
      )
      .subscribe((pod: IShipmentLocation) => this.store.dispatch(new PointOfDeliverySetAction(pod)));
  }
}
